// extracted by mini-css-extract-plugin
var _1 = "TutorialModal__barLegend--PMPOR";
var _2 = "TutorialModal__bbBucks--KzF5Q";
var _3 = "TutorialModal__bbButtonInText--J8IB0 TutorialModal__bbButtonSquare--nQstE";
var _4 = "TutorialModal__bbButtonSquare--nQstE";
var _5 = "TutorialModal__bbPartShop--hKL9M";
var _6 = "TutorialModal__bbSingleLayerPart--FGUtB";
var _7 = "TutorialModal__bbSingleSelectedPart--F3qof";
var _8 = "TutorialModal__beast--j36Im";
var _9 = "TutorialModal__bg--xMp82";
var _a = "TutorialModal__blueButtonInner--fQre2";
var _b = "TutorialModal__blueButtonOuter--obpzW";
var _c = "TutorialModal__bottomButton--ACfiB";
var _d = "TutorialModal__bottomButtonInner--SG9yg";
var _e = "TutorialModal__bottomButtonOuter--kQBvB TutorialModal__blueButtonOuter--obpzW";
var _f = "TutorialModal__bugReport--N4Rso";
var _10 = "TutorialModal__centered--T6cQZ";
var _11 = "TutorialModal__closeButton--Hp7B5";
var _12 = "TutorialModal__content--dvsIg fontSize__instructions--TOHcR CoreGeneral__roboto--UlmjE";
var _13 = "TutorialModal__contentBeast--YTIjC";
var _14 = "TutorialModal__count--Y2m3N";
var _15 = "TutorialModal__detailAvatar--rY9_M TutorialModal__detailIcon--GSCfL";
var _16 = "TutorialModal__detailHome--YjWYA";
var _17 = "TutorialModal__detailIcon--GSCfL";
var _18 = "TutorialModal__dot--nB8RS";
var _19 = "TutorialModal__expandInner--FTI0S TutorialModal__blueButtonInner--fQre2";
var _1a = "TutorialModal__expandOuter--ju5FH TutorialModal__blueButtonOuter--obpzW";
var _1b = "TutorialModal__iconShadow--TragW";
var _1c = "TutorialModal__inlineIcon--rMNTp";
var _1d = "TutorialModal__inlineImage--s1bbg";
var _1e = "TutorialModal__inlineOuter--dYdY2";
var _1f = "TutorialModal__labLongIcon--Gmden";
var _20 = "TutorialModal__left--HsLBA";
var _21 = "TutorialModal__level--jzQkf";
var _22 = "TutorialModal__list--FlozP";
var _23 = "TutorialModal__listNoBullet--lbvH1";
var _24 = "TutorialModal__longIcon--wKJzC";
var _25 = "TutorialModal__main--Yk4Kw";
var _26 = "TutorialModal__outer--lUpzJ";
var _27 = "TutorialModal__outerBar--jueqr TutorialModal__outer--lUpzJ";
var _28 = "TutorialModal__privacyTerms--kvilE CoreGeneral__robotoSlab--X8lgW fontSize__helpPrivacyTerms--Fd3Ql";
var _29 = "TutorialModal__question--l6Jao";
var _2a = "TutorialModal__report--hFRwr";
var _2b = "TutorialModal__restartDemo--DEB_j";
var _2c = "TutorialModal__restartTutorial--p8SdR TutorialModal__restartDemo--DEB_j";
var _2d = "TutorialModal__right--W_449";
var _2e = "TutorialModal__saveanswerInner--cszQS TutorialModal__blueButtonInner--fQre2";
var _2f = "TutorialModal__saveanswerOuter--jQkiO TutorialModal__blueButtonOuter--obpzW";
var _30 = "TutorialModal__screenshot--HPeZn";
var _31 = "TutorialModal__screenshotImg--KJnFE";
var _32 = "TutorialModal__scrollContent--m5ppe";
var _33 = "TutorialModal__selectallInner--z4i5Z TutorialModal__blueButtonInner--fQre2";
var _34 = "TutorialModal__selectallOuter--KwJXd TutorialModal__blueButtonOuter--obpzW";
var _35 = "TutorialModal__setButton--piMUw";
var _36 = "TutorialModal__sharpShadowIcon--V_bQM";
var _37 = "TutorialModal__sharpShadowRightIcon--CsSrF";
var _38 = "TutorialModal__signout--Ud_y6";
var _39 = "TutorialModal__singleButton--KxbEa";
var _3a = "TutorialModal__sliderDemo--GejTO";
var _3b = "TutorialModal__sliderGrade--hJhCr";
var _3c = "TutorialModal__sliderIcon--JXgeU";
var _3d = "TutorialModal__sliderTab--Zs7CD";
var _3e = "TutorialModal__sliderTabMain--DLEEh";
var _3f = "TutorialModal__sliderTabMainTeacher--QkNqS";
var _40 = "TutorialModal__starBar--qsPsq";
var _41 = "TutorialModal__subtitle--mYgIW fontSize__profileHead--IaEKt CoreGeneral__robotoSlab--X8lgW";
var _42 = "TutorialModal__tabOnly--n64jX";
var _43 = "TutorialModal__test-progress-bubbles--SmejZ";
var _44 = "TutorialModal__testsummaryInner--cpwg0 TutorialModal__blueButtonInner--fQre2";
var _45 = "TutorialModal__testsummaryOuter--JWNaS TutorialModal__blueButtonOuter--obpzW";
var _46 = "TutorialModal__textImg--c2eg7";
var _47 = "TutorialModal__theaterLongIcon--w9VuL";
var _48 = "TutorialModal__theaterSmallerIcon--wupNp";
var _49 = "TutorialModal__title--iahlk CoreGeneral__robotoSlab--X8lgW";
var _4a = "TutorialModal__topbarBg--TcNHW";
var _4b = "TutorialModal__topbarUser--ZXN9L";
var _4c = "TutorialModal__topbarWrapper--ao9y1";
var _4d = "TutorialModal__up--OOdZK";
export { _1 as "barLegend", _2 as "bbBucks", _3 as "bbButtonInText", _4 as "bbButtonSquare", _5 as "bbPartShop", _6 as "bbSingleLayerPart", _7 as "bbSingleSelectedPart", _8 as "beast", _9 as "bg", _a as "blueButtonInner", _b as "blueButtonOuter", _c as "bottomButton", _d as "bottomButtonInner", _e as "bottomButtonOuter", _f as "bugReport", _10 as "centered", _11 as "closeButton", _12 as "content", _13 as "contentBeast", _14 as "count", _15 as "detailAvatar", _16 as "detailHome", _17 as "detailIcon", _18 as "dot", _19 as "expandInner", _1a as "expandOuter", _1b as "iconShadow", _1c as "inlineIcon", _1d as "inlineImage", _1e as "inlineOuter", _1f as "labLongIcon", _20 as "left", _21 as "level", _22 as "list", _23 as "listNoBullet", _24 as "longIcon", _25 as "main", _26 as "outer", _27 as "outerBar", _28 as "privacyTerms", _29 as "question", _2a as "report", _2b as "restartDemo", _2c as "restartTutorial", _2d as "right", _2e as "saveanswerInner", _2f as "saveanswerOuter", _30 as "screenshot", _31 as "screenshotImg", _32 as "scrollContent", _33 as "selectallInner", _34 as "selectallOuter", _35 as "setButton", _36 as "sharpShadowIcon", _37 as "sharpShadowRightIcon", _38 as "signout", _39 as "singleButton", _3a as "sliderDemo", _3b as "sliderGrade", _3c as "sliderIcon", _3d as "sliderTab", _3e as "sliderTabMain", _3f as "sliderTabMainTeacher", _40 as "starBar", _41 as "subtitle", _42 as "tabOnly", _43 as "test-progress-bubbles", _44 as "testsummaryInner", _45 as "testsummaryOuter", _46 as "textImg", _47 as "theaterLongIcon", _48 as "theaterSmallerIcon", _49 as "title", _4a as "topbarBg", _4b as "topbarUser", _4c as "topbarWrapper", _4d as "up" }
